import React from "react";
import { ShieldCheck, Check, Zap, Rocket } from "lucide-react";

interface FeaturesGridProps {
  features: string[];
}

const FeaturesGrid: React.FC<FeaturesGridProps> = ({ features }) => {
  return (
    <div className="relative overflow-hidden rounded-2xl border border-navy-700 bg-gradient-to-br from-white to-gray-50 p-8 shadow-[0_8px_24px_rgba(0,31,63,0.08)]">
      {/* Encabezado con gradiente */}
      <div className="mb-12 flex items-start justify-between">
        <div>
          <h2 className="text-2xl lg:text-3xl font-bold text-navy-900">
            <span className="bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent">
              Key
            </span>
            <br />
            Features & Benefits
          </h2>
          <p className="mt-2 text-navy-700">Premium functionality included</p>
        </div>
        <ShieldCheck className="h-12 w-12 text-navy-700" />
      </div>

      {/* Grid de características moderno */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {features.map((feature, index) => (
          <div
            key={index}
            className="group relative flex items-start rounded-xl border-2 border-transparent bg-white p-6 transition-all
                     duration-300 hover:border-blue-200 hover:shadow-[0_8px_16px_rgba(0,119,255,0.1)]"
          >
            {/* Borde animado */}
            <div className="absolute inset-0 rounded-xl border-2 border-blue-100 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
            
            {/* Icono con efecto gradiente */}
            <div className="mr-4 flex h-12 w-12 items-center justify-center rounded-lg bg-gradient-to-br from-blue-50 to-cyan-50">
              {index % 2 === 0 ? (
                <Check className="w-5 h-5 text-blue-600" />
              ) : (
                <Zap className="w-5 h-5 text-cyan-600" />
              )}
            </div>
            
            {/* Contenido */}
            <div>
              <h3 className="text-lg font-semibold text-navy-900">{feature}</h3>
              <p className="mt-2 text-sm text-navy-700">
                {index % 3 === 0 && "Optimized performance"}
                {index % 3 === 1 && "Enterprise-grade security"}
                {index % 3 === 2 && "24/7 support included"}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Pie decorativo */}
      <div className="mt-12 flex items-center justify-center gap-4 text-sm text-navy-700">
        <div className="h-px w-24 bg-navy-700" />
        <Rocket className="w-5 h-5 text-cyan-600" />
        <span>Production Ready Solutions</span>
        <div className="h-px w-24 bg-navy-700" />
      </div>
    </div>
  );
};

export default FeaturesGrid;